import twilioService from '../TwilioService';

export class NativeTwilioAdapter {
    constructor(mobile) {
        this.mobile = mobile;
    }

    async isSupported() {
        try {
            return await this.mobile.request('twilioIsSupported');
        } catch {
            return false;
        }
    }

    async register() {
        const token = await twilioService.getToken();
        await this.mobile.request('twilioRegister', { token });
    }

    async connect(params = {}) {
        const token = twilioService.getCurrentToken() || await twilioService.getToken();
        await this.mobile.request('twilioConnect', { token, params });
    }

    async disconnect() {
        await this.mobile.request('twilioDisconnect');
    }

    async acceptInvite() {
        await this.mobile.request('twilioAcceptInvite');
    }

    async rejectInvite() {
        await this.mobile.request('twilioRejectInvite');
    }

    async mute(muted = true) {
        await this.mobile.request('twilioMuteCall', { muted });
    }

    async hold(hold = true) {
        await this.mobile.request('twilioHoldCall', { hold });
    }

    async sendDigits(digits) {
        await this.mobile.request('twilioSendDigits', { digits });
    }

    async getCallState() {
        return await this.mobile.request('twilioGetCallState');
    }

    isReady() {
        return true;
    }

    getClient() {
        return null;
    }
}
